<template>
    <div class="p-form__box c-mx-a">
        <form>
            <div class="p-form__item">
                <label class="p-form__label" for="referrer_name">
                    紹介者のお名前（登録名）
                    <span class="p-form__badge">必須</span>
                </label>
                <input class="p-form__input" type="text" name="referrer_name" v-model="referrer_name" required>

                <p v-if="error?.referrer_name" class="error_text">{{ error.referrer_name[0] }}</p>

            </div>

            <div class="p-form__item">
                <label class="p-form__label" for="mail_contact">
                    紹介者のメールアドレス
                    <span class="p-form__badge">必須</span>
                </label>
                <input class="p-form__input" type="email" name="referrer_email" v-model="referrer_email" required>

                <p v-if="error?.referrer_email" class="error_text">{{ error.referrer_email[0] }}</p>

            </div>

            <div class="p-form__item">
                <label class="p-form__label" for="friend_name">
                    ご友人のお名前
                    <span class="p-form__badge">必須</span>
                </label>
                <input class="p-form__input" type="text" name="friend_name" v-model="friend_name" required>

                <p v-if="error?.friend_name" class="error_text">{{ error.friend_name[0] }}</p>
  
            </div>

            <div class="p-form__item">
                <label class="p-form__label" for="friend_contact">
                    ご友人のメールアドレス
                    <span class="p-form__badge">必須</span>
                </label>
                <input class="p-form__input" type="email" name="friend_email" v-model="friend_email"
                    required>

                <p v-if="error?.friend_email" class="error_text">{{ error.friend_email[0] }}</p>

            </div>

            <div class="p-form__item">
                <label class="p-form__label" for="friend_career">
                    ご友人の職種・経験年数（任意）
                </label>
                <input class="p-form__input" type="text" name="friend_career" v-model="friend_career">
                <p v-if="error?.friend_career" class="error_text">{{ error.friend_career[0] }}</p>
            </div>

            <p class="p-form__links">
                <a :href="link_services_legal" target="_blank">「利用規約」</a>
                と<a href="https://www.e-xtreme.co.jp/privacy/" target="_blank">
                    「個人情報の取り扱い」</a>をご確認の上、「紹介情報を送信する」を押してください。
            </p>
            <button class="c-btn p-form__submit c-mx-a" type="button"
                @click="sendMail()">紹介情報を送信する</button>
        </form>
        <div class="p-form__notes">
            <p>※事前にご友人の同意を得た上でご入力ください</p>
            <p>※紹介の有効期限はフォーム受領から6ヶ月です</p>
            <p>※エクストリームフリーランスを過去にご利用された方は対象外となります</p>
        </div>
    </div>
    <loading :loading="loading"></loading>
</template>
<script>
import http from '../../util/http.js';
import utilMessage from '../../util/message.js'
import Loading from '../common/Loading.vue';
export default {
    components: {
        Loading
    },
    props:{
        link_services_legal: String,
    },
    data() {
        return {
            referrer_name: '',
            referrer_email: '',
            friend_name: '',
            friend_email: '',
            friend_career: '',
            loading: false,
            error: null,
        }
    },
    methods: {
        async sendMail() {
            const data = {
                referrer_name: this.referrer_name,
                referrer_email: this.referrer_email,
                friend_name: this.friend_name,
                friend_email: this.friend_email,
                friend_career: this.friend_career,
            };
            this.loading = true;
            await http.post('api/referral/send-mail', data)
                .then(response => {
                    console.log(response.data);
                    this.loading = false;
                    utilMessage.showMessage(response.data.message,this.$toast);
                    this.resetForm();
                })
                .catch(error => {
                    this.loading = false;
                    this.error = error.response.data.errors;
                });
        },
        resetForm() {
            this.referrer_name = '';
            this.referrer_email = '';
            this.friend_name = '';
            this.friend_email = '';
            this.friend_career = '';
        }
    }
}
</script>